import { getIn, useFormikContext } from "formik";
import { HelperText } from "components/DesignSystem/HelperText/HelperText";

export const SensitiveDataFieldError = ({ name }: { name: string }) => {
  const { errors, touched, submitCount } = useFormikContext();

  const error = getIn(errors, name);
  const isShown = Boolean(getIn(touched, name)) || submitCount > 0;

  if (!error || !isShown) return null;

  return <HelperText variant="error">{String(error)}</HelperText>;
};
